exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loader {\n  font-size: 10px;\n  margin: 50px auto;\n  text-indent: -9999em;\n  width: 6em;\n  height: 6em;\n  border-radius: 50%;\n  background: #337ab7;\n  background: linear-gradient(to right, #337ab7 10%, rgba(0,0,255, 0) 42%);\n  position: relative;\n  animation: load3 1.5s infinite linear;\n  transform: translateZ(0);\n  overflow: hidden;\n}\n.loader:before {\n  width: 50%;\n  height: 50%;\n  background: #337ab7;\n  border-radius: 100% 0 0 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  content: '';\n}\n.loader:after {\n  background: #ffffff;\n  width: 75%;\n  height: 75%;\n  border-radius: 50%;\n  content: '';\n  margin: auto;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n@keyframes load3 {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loading.component.css
// module id = 862
// module chunks = 1